import React from "react";
import api from "../../../services/api";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { pt } from "yup-locale-pt";
import { useStoreActions } from "easy-peasy";
import { TextField } from "../../../components";
import {
  Box,
  FormControl,
  Button,
} from "@mui/material";
yup.setLocale(pt);

const Observacoes = ({empresa, cnae, ano}) => {
  let startLoading = useStoreActions((actions) => actions.nav.startLoading);
  let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);

  const schema = yup
    .object({
      observacoes: yup
        .string()
        .max(1000, "Máximo 1000 caracteres")
        .label(
          "Deixe seu comentário ou outras informações que considerar importante"
        ),
    })
    .required();

  const useFormRef = useForm({
    mode: "onTouched",
    resolver: yupResolver(schema),
  });


  const {
    handleSubmit,
    reset,
    formState: { isDirty, isSubmitting },
  } = useFormRef;

  const loadObservacoes = async (mount) => {
    startLoading();
    try {
      let url = "00a/dados/empresa/" + empresa + "/cnae/" + cnae + "/" + ano;
      let getObservacoes = (await api.http.get(url));
      if (mount.isMounted)
        reset(getObservacoes.data);
      stopLoading();
    } catch (error) {
      if(error.response && error.response.status==404) {
        if(mount.isMounted) {
          reset({
            ano: ano,
            observacoes: ""
          });
        }
        stopLoading();
      } else {
        stopLoading({
          message: error.toString(),
          severity: "error",
        });
      }
    }
  };

  const submit = async (data) => {
    startLoading();
    try {
      let result;
      if (data.id) {
        result = (await api.http.put(
          "00a/dados/empresa/" + empresa + "/cnae/" + cnae + "/" + data.id,
          { ...data, ano: ano }
        ));
      } else {
        result = (await api.http.post(
          "00a/dados/empresa/" + empresa + "/cnae/" + cnae,
          { ...data, ano: ano }
        ));
      }
      reset(result.data);
      stopLoading({ severity: "success" });
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: "error",
      });
      throw error;
    }
  };

  React.useEffect(() => {
    let mount = {
      isMounted: true
    };
    if(empresa && cnae)
      loadObservacoes(mount);
    return () => {
      mount.isMounted = false;
    };
  }, [ano, cnae, empresa]);

  return (
    <div>
      <FormControl sx={{ my: 2 }} fullWidth>
        <TextField
          field="observacoes"
          multiline
          rows={4}
          schema={schema}
          useFormRef={useFormRef}
          inputProps={{ maxLength: 1000 }}
        />
      </FormControl>
      <Box>
        <Button variant="outlined" sx={{ mr: 2 }}
                onClick={()=>{reset();}} disabled={!isDirty || isSubmitting}>
          CANCELAR
        </Button>
        <Button
          type="submit"
          variant="contained"
          sx={{ m: 1 }}
          onClick={handleSubmit(submit)}
          disabled={!isDirty || isSubmitting}
        >
          Salvar
        </Button>
      </Box>
    </div>
  );
};

export default Observacoes;
